import { motion } from "framer-motion";
import { MapPin, TrainFront } from "lucide-react";
import { IMG, MAPS_URL, MAP_EMBED } from "../config";
import { ChapterHead } from "./ChapterHead";

export const Location = ({ t }) => (
    <section data-testid="location-section" className="relative bg-[#1b0b06] py-20 text-[#fbf3e8] sm:py-28">
        <span aria-hidden className="font-display pointer-events-none absolute -left-4 top-8 z-0 select-none text-[16rem] font-black leading-none text-[rgba(251,243,232,0.06)] sm:text-[22rem]">02</span>
        <div className="relative z-10 mx-auto grid max-w-7xl gap-12 px-5 sm:px-6 lg:grid-cols-2 lg:gap-16">
            <div className="order-2 lg:order-1">
                <div className="relative h-full min-h-[380px]">
                    <motion.div
                        initial={{ opacity: 0, x: -60 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                        className="absolute inset-0 overflow-hidden rounded-3xl"
                    >
                        <img src={IMG.lounge} alt="Rua tranquila do hostel em Copacabana" className="h-full w-full object-cover" />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#1b0b06]/70 to-transparent" />
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.5, duration: 0.6 }}
                        className="absolute bottom-5 left-5 right-5 flex items-center gap-3 rounded-2xl border border-[#fbf3e8]/15 bg-[#1b0b06]/70 p-4 backdrop-blur-md"
                    >
                        <MapPin className="shrink-0 text-[#f23218]" size={20} />
                        <div>
                            <p data-testid="location-address" className="text-sm font-bold">{t.location.address}</p>
                            <a
                                href={MAPS_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="location-maps-link"
                                className="text-xs font-semibold uppercase tracking-wider text-[#faff00] underline underline-offset-4 hover:text-white"
                            >
                                {t.location.maps}
                            </a>
                        </div>
                    </motion.div>
                </div>
            </div>
            <div className="order-1 flex flex-col justify-center lg:order-2">
                <ChapterHead dark chapter={t.location.chapter} label={t.location.label} title={t.location.title} />
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, delay: 0.15 }}
                    className="max-w-lg text-sm leading-relaxed text-[#fbf3e8]/70 sm:text-base"
                >
                    {t.location.text}
                </motion.p>
                <ul className="mt-8 divide-y divide-[#fbf3e8]/10 border-y border-[#fbf3e8]/10">
                    {t.location.items.map(([place, time], i) => (
                        <motion.li
                            key={place}
                            initial={{ opacity: 0, x: 24 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.5, delay: i * 0.08 }}
                            data-testid={`location-item-${i}`}
                            className="group flex items-center justify-between py-3.5"
                        >
                            <span className="flex items-center gap-3 text-sm font-semibold sm:text-base">
                                <TrainFront size={15} className="text-[#f23218] transition-transform group-hover:-translate-y-0.5" />
                                {place}
                            </span>
                            <span className="font-display text-sm font-bold italic text-[#faff00]">{time}</span>
                        </motion.li>
                    ))}
                </ul>
            </div>
        </div>
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7 }}
            className="relative z-10 mx-auto mt-14 max-w-7xl px-5 sm:px-6"
        >
            <div className="overflow-hidden rounded-3xl border border-[#fbf3e8]/10 shadow-2xl">
                <iframe
                    data-testid="location-map"
                    title="Mapa — Matianellu Hostel"
                    src={MAP_EMBED}
                    className="h-[360px] w-full sm:h-[420px]"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
        </motion.div>
    </section>
);
